import React, { useMemo } from 'react';

import { getTableCellPlainTextStyle } from '../utils/dataUtils/cell/tableCellPlainTextStyleUtils';

type Props = {
    plainText: string;
    style: React.CSSProperties;
    textStyle?: string[];
};

const TableCellPlainTextRenderer: React.FC<Props> = ({ plainText, style, textStyle }) => {
    const plainTextLines = useMemo(() => plainText.split('\n'), [plainText]);
    const plainTextSpanCssStyle = useMemo<React.CSSProperties>(
        () => getTableCellPlainTextStyle(textStyle),
        [textStyle],
    );

    return (
        <p className="TableCellPlainTextRenderer" style={style}>
            {plainTextLines.map((line, index) => (
                <span key={index} className="TableCellPlainTextRenderer-line" style={plainTextSpanCssStyle}>
                    {line}
                </span>
            ))}
        </p>
    );
};

export default TableCellPlainTextRenderer;
